/**
 * Form Factor Audio — Theme JavaScript
 *
 * Structured for soft (pjax) navigation: everything that binds to elements
 * INSIDE <main> lives in window.FFAInitPage() and is re-run after every soft
 * page swap (see pjax.js). Document-level / header handlers are bound ONCE below
 * and must never be re-bound (they'd double-fire).
 */
(function () {
  'use strict';

  /* ================= ONE-TIME, document-level (never re-run) ================= */

  /* ---------- Mobile Menu Toggle (header persists across soft nav) ---------- */
  (function initHeaderMenu() {
    var mobileToggle = document.querySelector('.mobile-menu-toggle');
    var navList = document.querySelector('.nav-list');
    if (mobileToggle && navList) {
      mobileToggle.addEventListener('click', function () {
        var isOpen = navList.classList.toggle('open');
        mobileToggle.setAttribute('aria-expanded', isOpen);
      });
      document.querySelectorAll('.nav-item.has-dropdown').forEach(function (item) {
        var parentLink = item.querySelector('.nav-link--parent');
        if (parentLink) {
          parentLink.addEventListener('click', function (e) {
            if (window.innerWidth <= 768) { e.preventDefault(); item.classList.toggle('open'); }
          });
        }
      });
    }
  })();

  /* ---------- Lightbox: one global keyboard handler (reads current controller) ---------- */
  var LB = null; // set by initLightbox() on each page that has a lightbox
  document.addEventListener('keydown', function (e) {
    if (!LB || !LB.el.classList.contains('is-open')) return;
    if (e.key === 'Escape') LB.close();
    else if (e.key === 'ArrowLeft' && LB.count > 1) LB.show(LB.idx - 1);
    else if (e.key === 'ArrowRight' && LB.count > 1) LB.show(LB.idx + 1);
  });

  /* ---------- Cart count badge helper ---------- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      }).catch(function () {});
  }
  window.FFARefreshCartCount = refreshCartCount;

  /* ---------- Main product Add to Cart → AJAX (never full-reload) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.product-form-main');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.btn-add-to-cart');
    if (!btn || btn.disabled) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
      .then(function () {
        btn.textContent = 'Added ✓';
        btn.classList.add('btn-add-to-cart--added');
        refreshCartCount();
        setTimeout(function () { btn.textContent = original; btn.classList.remove('btn-add-to-cart--added'); btn.disabled = false; }, 2200);
      })
      .catch(function () { btn.textContent = original; btn.disabled = false; form.submit(); });
  });

  /* ---------- "Complete Your Rig" AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.rig__form');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.rig__add');
    if (!btn || btn.disabled) return;
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
      .then(function () {
        btn.textContent = 'Added ✓';
        btn.classList.add('rig__add--added');
        refreshCartCount();
        setTimeout(function () { btn.textContent = originalText; btn.classList.remove('rig__add--added'); btn.disabled = false; }, 2200);
      })
      .catch(function () { btn.textContent = originalText; btn.disabled = false; form.submit(); });
  });

  /* ---------- Stand color-chart swatches (delegated, drive the hidden Color <select>) ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.scc__sw');
    if (!sw) return;
    var chart = sw.closest('.scc');
    var idx = chart.getAttribute('data-color-index');
    var select = document.getElementById('option-' + idx);
    if (select) { select.value = sw.getAttribute('data-value'); select.dispatchEvent(new Event('change')); }
    chart.querySelectorAll('.scc__sw').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
    sw.setAttribute('aria-pressed', 'true');
    var sel = chart.querySelector('[data-scc-selected]');
    if (sel) sel.innerHTML = 'Selected: <b>' + sw.getAttribute('data-name') + '</b>';
  });

  /* ---------- Two-tone stand swatch pick (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.stt__sw');
    if (!sw) return;
    var picker = sw.closest('.stt__picker');
    picker.querySelectorAll('.stt__sw').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
    sw.setAttribute('aria-pressed', 'true');
    var input = picker.querySelector('[data-stt-input]');
    if (input) input.value = sw.getAttribute('data-value');
    var label = picker.querySelector('[data-stt-selected]');
    if (label) label.innerHTML = 'Selected: <b>' + sw.getAttribute('data-name') + '</b>';
  });

  /* ================= PER-PAGE (re-run after every soft nav) ================= */
  window.FFAInitPage = function () {
    var mainImage = document.getElementById('product-main-image');
    var thumbs = document.querySelectorAll('.product-gallery__thumb');
    var zoomTrigger = document.querySelector('[data-product-zoom-trigger]');
    var galleryIndex = 0;

    function setActiveThumb(idx) {
      thumbs.forEach(function (t) { t.classList.toggle('active', parseInt(t.getAttribute('data-index'), 10) === idx); });
    }

    /* Gallery thumbnails */
    if (thumbs.length && mainImage) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var imageUrl = this.getAttribute('data-image-url');
          var idx = parseInt(this.getAttribute('data-index'), 10);
          if (imageUrl) {
            mainImage.src = imageUrl;
            galleryIndex = isNaN(idx) ? 0 : idx;
            setActiveThumb(galleryIndex);
            if (zoomTrigger) zoomTrigger.setAttribute('data-zoom-index', String(galleryIndex));
          }
        });
      });
    }

    /* Lightbox controls */
    LB = null;
    var lightbox = document.getElementById('productLightbox');
    var lightboxImage = document.getElementById('productLightboxImage');
    var lightboxCaption = document.getElementById('productLightboxCaption');
    var dataNode = document.getElementById('product-lightbox-data');
    if (lightbox && lightboxImage && dataNode) {
      var images = [];
      try { images = JSON.parse(dataNode.textContent || '[]'); } catch (e) { images = []; }
      var ctl = {
        el: lightbox, count: images.length, idx: 0,
        show: function (i) {
          if (!images.length) return;
          ctl.idx = (i + images.length) % images.length;
          var item = images[ctl.idx];
          lightboxImage.src = item.url; lightboxImage.alt = item.alt || '';
          if (lightboxCaption) lightboxCaption.textContent = (ctl.idx + 1) + ' / ' + images.length;
          if (mainImage && thumbs[ctl.idx]) {
            var tu = thumbs[ctl.idx].getAttribute('data-image-url');
            if (tu) mainImage.src = tu;
            setActiveThumb(ctl.idx);
          }
        },
        open: function (i) {
          if (!images.length) return;
          ctl.show(i);
          lightbox.classList.add('is-open'); lightbox.setAttribute('aria-hidden', 'false');
          document.body.classList.add('lightbox-open');
          lightbox.querySelectorAll('.product-lightbox__nav').forEach(function (n) { n.style.display = images.length > 1 ? '' : 'none'; });
        },
        close: function () {
          lightbox.classList.remove('is-open'); lightbox.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('lightbox-open');
        }
      };
      LB = ctl;
      if (zoomTrigger) zoomTrigger.addEventListener('click', function () { ctl.open(parseInt(zoomTrigger.getAttribute('data-zoom-index'), 10) || 0); });
      lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (el) { el.addEventListener('click', ctl.close); });
      var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
      var nextBtn = lightbox.querySelector('[data-lightbox-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { ctl.show(ctl.idx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { ctl.show(ctl.idx + 1); });
    }

    /* Variant selector */
    var variantSelects = document.querySelectorAll('.variant-select');
    var variantIdSelect = document.getElementById('product-variant-id');
    var priceDisplay = document.getElementById('product-price');
    var addToCartBtn = document.querySelector('.btn-add-to-cart');

    function updateVariant() {
      var selectedOptions = [];
      variantSelects.forEach(function (s) { selectedOptions.push(s.value); });
      var selectedTitle = selectedOptions.join(' / ');
      for (var i = 0; i < variantIdSelect.options.length; i++) {
        var option = variantIdSelect.options[i];
        if (option.text.trim() === selectedTitle || (selectedOptions.length === 1 && option.text.trim().includes(selectedOptions[0]))) {
          variantIdSelect.selectedIndex = i;
          if (priceDisplay) priceDisplay.textContent = option.getAttribute('data-price');
          if (window.__ffaVariantImages === undefined) {
            var vmEl = document.getElementById('variant-image-map');
            try { window.__ffaVariantImages = vmEl ? JSON.parse(vmEl.textContent) : {}; } catch (err) { window.__ffaVariantImages = {}; }
          }
          var vimg = window.__ffaVariantImages[option.value];
          if (vimg) {
            var mi = document.getElementById('product-main-image');
            if (mi) mi.src = vimg;
            document.querySelectorAll('.product-gallery__thumb').forEach(function (t) { t.classList.remove('active'); });
          }
          if (addToCartBtn) {
            if (option.disabled) { addToCartBtn.disabled = true; addToCartBtn.textContent = 'Sold Out'; }
            else { addToCartBtn.disabled = false; addToCartBtn.textContent = 'Add to Cart'; }
          }
          break;
        }
      }
    }
    if (variantSelects.length && variantIdSelect) {
      variantSelects.forEach(function (select) { select.addEventListener('change', updateVariant); });
    }

    /* Quantity */
    document.querySelectorAll('.quantity-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = this.parentElement.querySelector('.quantity-input');
        var v = parseInt(input.value) || 1;
        if (this.getAttribute('data-action') === 'increase') input.value = v + 1;
        else if (this.getAttribute('data-action') === 'decrease' && v > 1) input.value = v - 1;
      });
    });

    /* Stand color chart — auto-select first swatch */
    var chart = document.querySelector('.scc');
    if (chart) { var firstSw = chart.querySelector('.scc__sw'); if (firstSw) firstSw.click(); }

    /* Two-tone stand — palette follows the finish select */
    var stt = document.querySelector('.stt');
    if (stt) {
      var currentFinish = function () { var sel = document.querySelector('.variant-select'); return sel ? sel.value : 'Textured Paint'; };
      var applyFinish = function (finish) {
        stt.querySelectorAll('.stt__picker').forEach(function (picker) {
          var visible = null;
          picker.querySelectorAll('.stt__grp').forEach(function (grp) {
            var match = grp.getAttribute('data-stt-grp') === finish;
            grp.hidden = !match;
            if (match) visible = grp;
          });
          picker.querySelectorAll('.stt__sw').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
          var input = picker.querySelector('[data-stt-input]');
          var label = picker.querySelector('[data-stt-selected]');
          var first = visible ? visible.querySelector('.stt__sw') : null;
          if (first) {
            first.setAttribute('aria-pressed', 'true');
            if (input) input.value = first.getAttribute('data-value');
            if (label) label.innerHTML = 'Selected: <b>' + first.getAttribute('data-name') + '</b>';
          } else { if (input) input.value = ''; if (label) label.textContent = ''; }
        });
      };
      document.querySelectorAll('.variant-select').forEach(function (sel) { sel.addEventListener('change', function () { applyFinish(currentFinish()); }); });
      applyFinish(currentFinish());
    }
  };

  /* Initial page load */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.FFAInitPage);
  else window.FFAInitPage();
})();
